import React from 'react';
import cs from 'classnames';
import moment from 'moment';
import ReactDatePicker, {
  ReactDatePickerProps,
  ReactDatePickerCustomHeaderProps,
} from 'react-datepicker-next';
import { makeStyles } from '../index';

import IconButton from '@material-ui/core/IconButton';
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore';
import NavigateNextIcon from '@material-ui/icons/NavigateNext';

interface DatePickerError {
  verifier: boolean;
  message: string;
}

interface NewDatePickerProps extends ReactDatePickerProps {
  errors?: DatePickerError[];
}

const useStyles = makeStyles(theme => ({
  root: {
    fontFamily: theme.typography.fontFamily,
  },
  calendar: {
    fontFamily: theme.typography.fontFamily,
    boxShadow: theme.boxShadowLarge,
    '& .react-datepicker__header': {
      backgroundColor: 'transparent',
      paddingTop: 0,
    },
    '& .react-datepicker__day--in-range': {
      backgroundColor: '#4C98D3',
    },
  },
  headerContainer: {
    display: 'flex',
    alignItems: 'center',
    fontSize: 14,
    fontWeight: 500,
    justifyContent: 'space-between',
    width: 'calc(100% - 16px)',
    padding: theme.spacing(1),
  },
  day: {
    borderRadius: '50%',
    '&:hover': {
      borderRadius: '50%',
    },
  },
  inputErrorMessage: {
    padding: '0 6px',
    fontSize: '12px',
    color: 'var(--color-RemoRed)',
  },
}));

function NewDatePicker({
  errors,
  className,
  calendarClassName,
  dayClassName,
  ...otherProps
}: NewDatePickerProps) {
  const classes = useStyles();

  function CustomHeader({
    date,
    decreaseMonth,
    increaseMonth,
    prevMonthButtonDisabled,
    nextMonthButtonDisabled,
  }: ReactDatePickerCustomHeaderProps) {
    return (
      <div className={classes.headerContainer}>
        <IconButton onClick={decreaseMonth} disabled={prevMonthButtonDisabled} size={'small'}>
          <NavigateBeforeIcon />
        </IconButton>
        <div>{moment(date).format('MMMM YYYY')}</div>
        <IconButton onClick={increaseMonth} disabled={nextMonthButtonDisabled} size={'small'}>
          <NavigateNextIcon />
        </IconButton>
      </div>
    );
  }

  return (
    <>
      <ReactDatePicker
        dayClassName={day => (dayClassName ? cs(classes.day, dayClassName(day)) : classes.day)}
        renderCustomHeader={CustomHeader}
        className={cs(classes.root, className)}
        calendarClassName={cs(classes.calendar, calendarClassName)}
        {...otherProps}
      />
      {errors &&
        errors.length > 0 &&
        errors.map(
          error =>
            error.verifier && <div className={classes.inputErrorMessage}>{error.message}</div>,
        )}
    </>
  );
}

export default NewDatePicker;
